import Skeleton from '@mui/material/Skeleton';
import React from 'react';

export const LoadingTitle: React.FC = () => (
  <Skeleton animation="wave" width="100%" height="1.8rem" />
);
